<template>
  <div class="widget-wrapper">
    <data-table ref="gpnSysModifyList"
                style="height: 100%"
                class="bs bs-data-table bs-data-table-slim analysis-panel-datatable"
                :data="widgetData"
                :fields="dataTableColumns"
                :virtual-scrolling="false"
    />
  </div>
</template>

<script>
  // 전역 이벤트버스 모듈
  import Bus from '~/plugins/event-hub'

  // Mixin 객체
  import Moment from 'moment'
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체
  const {mapGetters} = createNamespacedHelpers('common/common')
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSysModifyList',
    components: {},
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        title: 'widgetSysModifyList',
        isMove: true,
        isSync: true,
        isLock: false,
        isResize: false,
        isRefresh: false,
        deviceType: [20, 21, 23],
        widgetData: [],
        timerValue: 10000,
        timerObject: null,
        lastEndTime: '', // TAMS 미사용
        currentSelect: {},
        // TAMS
        isRealtime: true,
        destroyCall: false
      }
    },
    computed: {
      ...mapGetters([
        'getDeviceTime'
      ]),
      dataTableColumns () {
        return [
          // TAMS
          {
            name: 'mach_name',
            align: 'left',
            title: this.$t('an.mach_id'),
            sorting: false
          },
          {
            name: 'admin_id',
            align: 'left',
            title: this.$t('dash.widgetSysModifyList_title_admin'),
            sorting: false
          },
          {
            name: 'admin_ip',
            align: 'left',
            title: this.$t('dash.widgetSysModifyList_title_adminIp'),
            sorting: false
          },
          {
            name: 'menu',
            align: 'left',
            title: this.$t('dash.widgetSysModifyList_title_settingMenu'),
            sorting: false
          },
          {
            name: 'time',
            align: 'left',
            title: this.$t('dash.widgetSysModifyList_title_modifyTime'),
            sorting: false
          }
        ]
      },
      preExecTask () {
        const dataTable = this.$refs.gpnSysModifyList
        return function () {
          dataTable.destroy()
        }
      }
    },
    beforeCreate () {},
    created () {
      this.destroyCall = false // TAMS
    },
    beforeMount () {},
    mounted () {
      // 최대화 팝업이 아닌 경우, 실시간 타이머 생성
      if (!this.isMaximumWidget && !this.destroyCall) {
        this.timerObject = setInterval(this.getWidgetContentsData, this.timerValue)
      }
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 비동기 콜로 인한 setInterval 타이밍 역전 현상 해결 위함 (TAMS)
      this.destroyCall = true

      // 타이머 객체가 있으면 타이머 소멸
      if (this.timerObject) {
        clearInterval(this.timerObject)
      }

      // 데이터 테이블 초기화
      this.$refs.gpnSysModifyList.destroy()

      // 모델 초기화
      this.widgetData = []
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      /*
        이름: getWidgetContentsData
        설명: REST API에서 데이터를 요청하고, 데이터 테이블에 값을 반영한다.
      */
      async getWidgetContentsData (init = false, extraParams = null) {
        const contentsOptions = {
          topN: 50,
          widgetType: 'system_config_status'
        }

        /*
          - 10초 데이터 초기화 시 (실시간 추이 데이터)
            [현재 장비시간의 -30초 ~ 1시간 이전] 데이터 호출 (TAMS 수정됨)
        */
        // 실시간 위젯은 위젯 데이터를 30초를 뺀 시간을 기준으로 한다. (Ex. 14:05:37초일 경우 기본 계산 시간은 14:05:07초)
        const calcBaseTime = Moment(this.getDeviceTime).subtract(30, 'seconds')

        // 계산된 시간에서 1초 단위를 초기화. (14:05:00)
        const endTime = calcBaseTime.seconds(this.floorSecondTime(calcBaseTime.seconds()))

        // 계산된 endTime에서 1시간 빼기. (13:05:00)
        const startTime = _.cloneDeep(endTime).subtract(1, 'hours')

        // endTime에서 1초 빼기 (14:04:59)
        contentsOptions.eTime = endTime.subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')

        // startTime 추가 (14:04:00 ~ 14:04:59로 최초 요청)
        contentsOptions.sTime = startTime.format('YYYY-MM-DD HH:mm:ss')

        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기화
        if (init) {
          this.widgetData = []
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        // 데이터 조회
        // const {code, eTime, result} = await this.getWidgetData(contentsOptions)
        // TAMS
        const {code, result} = await this.getWidgetData(contentsOptions)

        // 마지막 Etime 저장
        // this.lastEndTime = eTime

        // REST API 조회에 성공할 경우
        if (code === 'ok') {
          // TAMS
          this.widgetData = result.result || []
        } else {
          this.widgetData = [] // TAMS
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {
      /*
        이름: widgetData
        설명: 원본 위젯 데이터가 변경되면 최대화 팝업 모델을 업데이트한다.
      */
      widgetData (widgetData) {
        // 최대화 위젯이 아니고, isSync를 사용하는 경우
        if (!this.isMaximumWidget && this.isSync) {
          // 데이터가 들어오면 최대화 팝업에 데이터 전달
          Bus.$emit(`${this.$options.name}_sync_maximumpopup`, { widgetData })
        }
      }
    }
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }
</style>
